import {RailsPdtConstants} from './RailsPdtConstants';
import {pushPdtData} from '../PdtAnalytics';
import RailsPdtTravellersEvent from '../PdtModel/PdtEvents/RailsPdtTravellersEvent';


export default class RailsPdtTravellersHelper {
  static trackPageLoad(data) {
    try {
      const pdtData = data;
      pdtData.activityName = RailsPdtConstants.BaseEventAction.LOAD_PAGE;
      const pdtObject = new RailsPdtTravellersEvent(pdtData).trackTravellersEvent();
      pushPdtData(pdtObject);
    } catch (e) {
      // ignore
    }
  }

  static trackPageExit(data) {
    try {
      const pdtData = data;
      pdtData.activityName = RailsPdtConstants.BaseEventAction.EXIT_PAGE;
      const pdtObject = new RailsPdtTravellersEvent(pdtData).trackTravellersEvent();
      pushPdtData(pdtObject);
    } catch (e) {
      // ignore
    }
  }

  static trackBackPressed(data) {
    try {
      const pdtData = data;
      pdtData.activityName = RailsPdtConstants.BaseEventAction.CLICK_BACK;
      const pdtObject = new RailsPdtTravellersEvent(pdtData).trackTravellersEvent();
      pushPdtData(pdtObject);
    } catch (e) {
      // ignore
    }
  }
}
